// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import RandomSvg from '@rsuite/icon-font/lib/flow/Random';
var Random = createSvgIcon({
  as: RandomSvg,
  ariaLabel: 'random',
  category: 'flow',
  displayName: 'Random'
});
export default Random;